import {GroupChannelIcon, PrivateChannelIcon, PublicChannelIcon} from '@time-webkit/all/icons';
import {ArchiveOutlineIcon} from '@time-webkit/all/icons/archive-outline';
import {ChannelType} from '@time-webkit/all/types/general';

export const getChannelIcon = (type: ChannelType, archived = false) => {
    if (archived) {
        return ArchiveOutlineIcon;
    }

    switch (type) {
    case ChannelType.PUBLIC:
        return PublicChannelIcon;
    case ChannelType.PRIVATE:
        return PrivateChannelIcon;
    case ChannelType.GM:
        return GroupChannelIcon;
    default:
        return PublicChannelIcon;
    }
};
